export enum LinkToSfdcContactEnum {
  LinkNotNeeded,
  LinkNeeded,
  LinkConfirmation,
}
